/** Chave da plataforma com o link da base de conhecimento. */
export const KNOWLEDGE_BASE_URL_KEY = 'knowledgeBaseUrl';

/**
 * Base universal, sem marca: vale enquanto o White Label não cadastra a dele.
 * Os artigos dela não citam nome de produto nem endereço, então servem para
 * qualquer marca.
 */
export const DEFAULT_KNOWLEDGE_BASE_URL = 'https://treinamentocrm.com.br/';
